import React from 'react';
import ReactTooltip from "react-tooltip";

import { PasswordSecurityConfig } from '../../models/signin/PasswordSecurityConfig';

export type PasswordTooltipProps = {
    passwordValidate: any;
    config: PasswordSecurityConfig;
};

export const PasswordHintTooltip = (props: PasswordTooltipProps) => {
    const { passwordValidate, config } = props;
    
    return (
        <ReactTooltip
            id="global"
            place="left"
            type="dark"
            effect="solid"
        >
            <ul>
                <li
                    style={{
                        color: passwordValidate['maxLength']
                            ? 'green'
                            : 'white'
                    }}
                >
                    {' '}
                    Maximum Password {config.max_password_length} character
                </li>
                <li
                    style={{ 
                        color: passwordValidate['length']
                            ? 'green'
                            : 'white'
                    }}
                >
                    {' '}
                    Minimum Password {config.min_password_length} character
                </li>
                {config.require_number === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numNums']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        At least 1 Number
                    </li>
                )}
                {config.require_uppercase === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numUpper']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        At least 1 UPPER CASE
                    </li>
                )}
                {config.require_lowercase === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numLower']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        At least 1 LOWER CASE
                    </li>
                )}
                {config.require_special_character === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numSpecials']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        At least 1 Special CASE
                    </li>
                )}
            </ul>
        </ReactTooltip>
    )
}